/**
 * sortProducts — reine Sortier-Helfer fuer die Produktliste (F10).
 *
 * Gibt eine SORTIERTE KOPIE zurueck; die Eingabe wird nicht mutiert.
 * 'relevance' => Eingabereihenfolge beibehalten (Treffer-/Backend-Reihenfolge).
 */

export const PRODUCT_SORT_OPTIONS = [
  { id: 'relevance', labelKey: 'products.sortRelevance', searchOnly: true },
  { id: 'name_asc',  labelKey: 'products.sortNameAsc' },
  { id: 'name_desc', labelKey: 'products.sortNameDesc' },
  { id: 'price_asc', labelKey: 'products.sortPriceAsc' },
  { id: 'price_desc', labelKey: 'products.sortPriceDesc' },
  { id: 'newest',    labelKey: 'products.sortNewest' },
];

const num = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};
const name = (p) => (p && p.name ? String(p.name) : '');
// Aktualitaet: created_at, sonst id als Fallback (Auto-Increment ~ Reihenfolge)
const recency = (p) => {
  if (p && p.created_at) {
    const t = new Date(p.created_at).getTime();
    if (Number.isFinite(t)) return t;
  }
  return p && p.id ? Number(p.id) || 0 : 0;
};

export function sortProducts(list, sortBy) {
  const arr = Array.isArray(list) ? [...list] : [];
  switch (sortBy) {
    case 'name_asc':   return arr.sort((a, b) => name(a).localeCompare(name(b), undefined, { sensitivity: 'base' }));
    case 'name_desc':  return arr.sort((a, b) => name(b).localeCompare(name(a), undefined, { sensitivity: 'base' }));
    case 'price_asc':  return arr.sort((a, b) => num(a.price) - num(b.price));
    case 'price_desc': return arr.sort((a, b) => num(b.price) - num(a.price));
    case 'newest':     return arr.sort((a, b) => recency(b) - recency(a));
    case 'relevance':
    default:           return arr; // Reihenfolge beibehalten
  }
}
